import { makeValidateCustomerDocumentRepository } from 'modules/authentication/infra/repositories';

import { ValidateCustomerDocumentUseCase } from './implementations/ValidateCustomerDocumentUseCase';

let instance: ValidateCustomerDocumentUseCase | null = null;

export default function makeValidateCustomerDocumentUseCase() {
  if (!instance) {
    const repository = makeValidateCustomerDocumentRepository();

    instance = new ValidateCustomerDocumentUseCase(repository);
  }

  return instance;
}
